import api from '../../utils/api'

export const state = {}

export const mutations = {}

export const actions = {
  async handleProcessChemicalAgentsFispq(_, body) {
    try {
      return await api.post(`/chemical-agent/agents-fispq`, body)
    } catch (e) {

    }
  }
}

export const getters = {}
